"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LocalizationUtility = _interopRequireDefault(require("../../../util/LocalizationUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used for fetching store availability data.
 */
var DexfStoreAvailabilityService = /*#__PURE__*/function () {
  function DexfStoreAvailabilityService() {
    _classCallCheck(this, DexfStoreAvailabilityService);
  }

  _createClass(DexfStoreAvailabilityService, null, [{
    key: "getStoreAvailabilities",

    /**
     * Authenticates and returns user.
     *
     * @param item Item.
     * @param storeId Store ID.
     * @param data Locale.
     * @returns Promise.
     */
    value: function () {
      var _getStoreAvailabilities = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item, storeId, data) {
        var endpoint, dexfApiKey, options, itemId, url, baseUrl, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                item = Object.assign({
                  storeId: storeId
                }, item);
                endpoint = data.endpoints.dexfStoreAvailabilityService;
                dexfApiKey = this._getDexfApiKey(data);
                options = {
                  credentials: 'same-origin',
                  headers: {
                    'dexf-api-key': dexfApiKey
                  }
                };
                itemId = this._getItemString(item);
                url = "".concat(endpoint.replace('{storeId}', encodeURIComponent(storeId.replace(/ /g, ''))), "?filter.itemId=").concat(itemId);
                baseUrl = this._getBaseUrl(url, data.apiLocalePath);
                _context.next = 9;
                return this._json(baseUrl, options);

              case 9:
                response = _context.sent;
                return _context.abrupt("return", this.transformResponse(response));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getStoreAvailabilities(_x, _x2, _x3) {
        return _getStoreAvailabilities.apply(this, arguments);
      }

      return getStoreAvailabilities;
    }()
    /**
     * Returns the service.
     *
     * @param {object} localizationData Localization data from LocalizationService.
     * @returns {string} DexfApiKey, public api key for the application.
     */

  }, {
    key: "_getDexfApiKey",
    value: function _getDexfApiKey(localizationData) {
      return _LocalizationUtility.default.getAppSettingValue(localizationData, 'dexfApiKey');
    }
    /**
     * Fetches JSON and handles error responses.
     *
     * @param requestInfo Request info.
     * @param [options] Fetch options.
     * @param [options.headers] Fetch options.
     * @param [options.credentials] Fetch options.
     * @returns Promise.
     */

  }, {
    key: "_json",
    value: function () {
      var _json2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(requestInfo, options) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return window.fetch(requestInfo, options);

              case 2:
                response = _context2.sent;

                if (!(typeof response.json === 'function')) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 4;
                _context2.next = 7;
                return response.json();

              case 7:
                return _context2.abrupt("return", _context2.sent);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                console.error(_context2.t0);

              case 13:
                return _context2.abrupt("return", response);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 10]]);
      }));

      function _json(_x4, _x5) {
        return _json2.apply(this, arguments);
      }

      return _json;
    }()
    /**
     * Returns an item string to be used in the request URL.
     *
     * @param {Object[]} itemSet Array of items.
     * @return {String} Item string.
     */

  }, {
    key: "_getItemString",
    value: function _getItemString(item) {
      return item.type.toUpperCase() + '-' + item.id;
    }
    /**
     * Returns the base URL to be used in request.
     *
     * @param {String} endpoint Api endpoint.
     * @param {String} apiLocalePath API locale path. Example: "gb/en".
     * @return {String} Base URL.
     */

  }, {
    key: "_getBaseUrl",
    value: function _getBaseUrl(endpoint, apiLocalePath) {
      var retailUnit = apiLocalePath.substr(0, 2).toUpperCase();
      var languageCode = apiLocalePath.substr(3, 2);
      var locale = languageCode + '-' + retailUnit;
      var baseUrl = endpoint.replace('{retailUnit}', retailUnit).replace('{locale}', locale);
      return baseUrl;
    }
    /**
     * Transforms the response and returns only valid items.
     *
     * @param response Response.
     * @param response.data
     * @returns Valid items.
     */

  }, {
    key: "transformResponse",
    value: function transformResponse(response) {
      var _iterator = _createForOfIteratorHelper(response.data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.valid && item.content) {
            if (item.content.cashCarry.salesLocations) {
              var _storeAvailability = {
                ID: item.content.itemNo,
                Type: item.content.itemType,
                StockAvailability: item.content.cashCarry.quantity,
                SalesLocation: this._getSalesLocation(item),
                InStockProbabilityCode: item.content.cashCarry.messageType,
                SalesMethodCode: item.content.cashCarry.salesLocations[0].division
              };
              return _storeAvailability;
            }

            var storeAvailability = {
              ID: item.content.itemNo,
              Type: item.content.itemType,
              StockAvailability: item.content.cashCarry.quantity,
              InStockProbabilityCode: item.content.cashCarry.messageType
            };
            return storeAvailability;
          }

          return {}; //Item not valid, return empty object.
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Returns sales location.
     *
     * @param {String} salesMethodCode Sales method code.
     * @param {Object} location Location object.
     * @return {Object} Sales location data.
     */

  }, {
    key: "_getSalesLocation",
    value: function _getSalesLocation(item) {
      var salesLocations = item.content.cashCarry.salesLocations[0];

      if (salesLocations.division == 'SELF_SERVE' && salesLocations.aisle && salesLocations.bin) {
        return {
          Aisle: salesLocations.aisle,
          Bin: salesLocations.bin
        };
      }

      if (salesLocations.departmentName) {
        return {
          Department: salesLocations.departmentName
        };
      }

      return null; // no useful SalesLocation values - contact co-worker
    }
  }]);

  return DexfStoreAvailabilityService;
}();

exports.default = DexfStoreAvailabilityService;